import { Injectable } from '@angular/core'
import { ChartModel } from './chart.model'
import { CmodalService } from '../cmodal/cmodal.service'
import * as echarts from 'echarts'
import { UtilService } from 'src/app/shared/util.service'
import { DomSanitizer } from '@angular/platform-browser'
import { AjaxService } from 'src/app/shared/ajax.service'
import { GlobService } from 'src/app/shared/glob.service'

@Injectable({
  providedIn: 'root'
})

export class ChartService {
  components: any[]
  thos: any = this
  constructor(private glob: GlobService, private util: UtilService, private cmodalService: CmodalService, private sanitized: DomSanitizer, private ajax: AjaxService) {
    for (let thm of this.glob.themes)
      echarts.registerTheme(thm.nam, thm.chart_cnf)
  }

  init(model: ChartModel) {
    setTimeout(() => {
      let chartDom = document.getElementById(model.id)
      model.chart = echarts.init(chartDom, this.glob.config.theme)
      if (model.lod) this.load(model)  
    }, 1000);
  }

  themer(model: ChartModel) {
    let chartDom = document.getElementById(model.id)
    model.chart = echarts.init(chartDom, this.glob.config.theme)
  }

  load(model: ChartModel) {
    if (model.pars && model.pars.filter(x => x.length == 4).length > 0) return
    let thos = this
    this.ajax.execute({
      url: 'chart/load',
      data: { id: model.id, pars: (model.pars ? model.pars : undefined) },
      success: (post: any) => {
        thos.generate(model, post.result)
      }
    })
  }

  async generate(model: ChartModel, data: any) {
    if (!data || data.length == 0) return

    let str = await this.util.exchange(JSON.stringify(model.cnf), { model: model, data }, { rem_qoat: true })
    model.cnf = JSON.parse(str.res)
    console.log(7002, model.cnf)
    model.chart.setOption(model.cnf)
  }

  color = {
    rand: () => {
      let r = Math.floor(Math.random() * 180)
      let g = Math.floor(Math.random() * 180)
      let b = Math.floor(Math.random() * 180)
      return [r, g, b]
    }
  }

  // ------- utilities ---------------------------------------
  switch_typ(typ: any): any {
    switch (typ) {
      case 1: return 'bar'
      case 2: return 'line'
      case 3: return 'pie'
      case 4: return 'radar'
      case 5: return 'polarArea'
      case 6: return 'bubble'
      case 7: return 'doughnut'
      case "bar": return 1
      case "line": return 2
      case "pie": return 3
      case "radar": return 4
      case "polarArea": return 5
      case "bubble": return 6
      case "doughnut": return 7
    }
  }

  modifier(chart: ChartModel) {
    chart.ssty = this.sanitized.bypassSecurityTrustStyle(chart.sty)
    chart.ctyp = 'chart'
    if (chart.dis == null) chart.dis = 2
  }
}